// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.gc-dashboard-wrapper {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.gc-dashboard-contant {
  flex: 1 1 auto;
  padding: 0 40px 40px 40px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
